import { useEffect } from "react";
import { Link } from "react-router-dom";
import "./ServiceDetail.css";

const TrainingService = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const programs = [
    {
      title: "Business & Leadership",
      duration: "12 Weeks",
      level: "Intermediate",
      topics: [
        "Strategic Management",
        "Financial Planning",
        "Team Leadership",
        "Project Management",
      ],
    },
    {
      title: "Software Development",
      duration: "16 Weeks",
      level: "Beginner to Advanced",
      topics: [
        "React & Node.js",
        "Database Design",
        "API Development",
        "DevOps Basics",
      ],
    },
    {
      title: "Digital Marketing",
      duration: "10 Weeks",
      level: "All Levels",
      topics: [
        "SEO & SEM",
        "Social Media Strategy",
        "Content Marketing",
        "Analytics",
      ],
    },
    {
      title: "Data Analytics",
      duration: "12 Weeks",
      level: "Intermediate",
      topics: [
        "Python & SQL",
        "Data Visualization",
        "Statistical Analysis",
        "Power BI",
      ],
    },
  ];

  return (
    <div className="service-detail-page">
      {/* Hero */}
      <section className="service-detail-hero">
        <div className="hero-particles"></div>
        <div className="container">
          <Link to="/services" className="back-link">
            ← Back to Services
          </Link>
          <div className="service-detail-hero-content">
            <div className="service-icon-hero">🎓</div>
            <h1>Business & Tech Training</h1>
            <p>
              Professional development programs designed to equip individuals
              and teams with in-demand skills for today's competitive market
            </p>
          </div>
        </div>
      </section>

      {/* Overview */}
      <section className="service-overview">
        <div className="container">
          <div className="overview-grid">
            <div className="overview-content">
              <h2>Transform Your Career</h2>
              <p>
                Our comprehensive training programs combine expert instruction
                with hands-on practice to ensure you gain practical skills that
                employers value. Whether you're looking to advance in your
                current career or transition to a new field, our courses provide
                the foundation you need.
              </p>
              <p>
                With over 500 successful graduates and a 95% satisfaction rate,
                LICO's training programs are trusted by professionals across
                Nigeria.
              </p>
            </div>
            <div className="overview-stats">
              <div className="stat-item">
                <div className="stat-number">500+</div>
                <div className="stat-label">Graduates</div>
              </div>
              <div className="stat-item">
                <div className="stat-number">95%</div>
                <div className="stat-label">Success Rate</div>
              </div>
              <div className="stat-item">
                <div className="stat-number">15+</div>
                <div className="stat-label">Programs</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Programs */}
      <section className="service-programs">
        <div className="container">
          <h2>Our Programs</h2>
          <div className="programs-grid">
            {programs.map((program, index) => (
              <div key={index} className="program-item">
                <h3>{program.title}</h3>
                <div className="program-meta">
                  <span>📅 {program.duration}</span>
                  <span>📊 {program.level}</span>
                </div>
                <ul className="program-topics">
                  {program.topics.map((topic, idx) => (
                    <li key={idx}>{topic}</li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="service-detail-cta">
        <div className="container">
          <h2>Ready to Get Started?</h2>
          <p>
            Join hundreds of professionals who have transformed their careers
            with LICO
          </p>
          <Link to="/contact-us" className="btn btn-light">
            Enroll Now
          </Link>
        </div>
      </section>
    </div>
  );
};

export default TrainingService;
